import { Toaster as Sonner, toast } from 'sonner';
import { useUiStore } from '@/stores/ui';

export function Toaster() {
  const theme = useUiStore((s) => s.theme);
  return (
    <Sonner
      theme={theme}
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'group toast border-line bg-bg-1 text-ink-1 shadow-lg',
          description: 'text-ink-2',
          actionButton: 'bg-brand text-white',
          cancelButton: 'bg-bg-3 text-ink-2',
        },
      }}
    />
  );
}

export { toast };
